/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Client_Case_TypeInputs */

const en_cases_col_client_case_type = /** @type {(inputs: Cases_Col_Client_Case_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client / Case Type`)
};

const pt_br2_cases_col_client_case_type = /** @type {(inputs: Cases_Col_Client_Case_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente / Tipo de caso`)
};

/**
* | output |
* | --- |
* | "Client / Case Type" |
*
* @param {Cases_Col_Client_Case_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_client_case_type = /** @type {((inputs?: Cases_Col_Client_Case_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Client_Case_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_client_case_type(inputs)
	return pt_br2_cases_col_client_case_type(inputs)
});